<template>
  <div class="block-job">
    <bim-text type="main" class="description__line mb-10 mt-9">
      Наши новые продукты требуют вовлечения большего количества специалистов, в связи с чем мы расширяем штат и ищем таланты в нашу дружную команду профессионалов, которые стремятся менять мир. И да, мы планируем вырастить единорога, если вы понимаете о чем мы.
    </bim-text>
    <bim-text type="accent" bold class="mb-9">Открытые вакансии</bim-text>
    <div class="faq-dropdown" v-for="(job, index) in jobs" :key="index" data-dropdown-wrapper>
      <div v-metric="'LENDING-BIM_CLICK-ON-FAQ'" class="faq-dropdown_top" data-dropdown-title>
        <p class="faq-dropdown_title">{{ job.title }}</p>
        <i class="icon-dropdown-light"></i>
      </div>
      <div class="faq-dropdown_content">
        <div class="content-wrapper">
          <div class="content-terms">
            <div class="vacancy_terms d-flex flex-nowrap mb-9 flex-column flex-sm-row">
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph__title op05 fz14 fw-bold">Опыт работы</span>
                <p class="paragraph__item fw-bold">{{ job.desc.expirience }}</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph__title op05 fz14 fw-bold">Занятость</span>
                <p class="paragraph__item fw-bold">{{ job.desc.employment }}</p>
              </div>
              <div class="vacancy_terms-block vacancy_terms-block--margin">
                <span class="paragraph__title op05 fz14 fw-bold">Оплата</span>
                <p class="paragraph__item fw-bold">{{ job.desc.payment }}</p>
              </div>
            </div>
          </div>
          <div>
            <div
              v-for="desc of job.desc.other"
              :key="desc.title"
              class="mt-9"
            >
              <h5 class="paragraph-list__title fw-bold mb-6 mb-sm-8">{{ desc.title }}</h5>
              <ul class="vacancy_list">
                <li
                  class="vacancy_list-item vacancy_list-item--margin paragraph-list__item"
                  v-for="item of desc.items"
                  :key="item"
                >{{ item }}</li>
              </ul>
            </div>
          </div>
          <bimButton
            size=l
            class="mt-9 mb-11"
            @click="openModalRequestVacancy(job.select)"
            label="Откликнуться"
          />
        </div>
      </div>
    </div>
    <div class="listVacancies_script"></div>
    <ModalRequestVacancy
      v-if="requestVacancy.show"
      @close="requestVacancy.show = false"
      :vacancy_select="requestVacancy.select"
    />
  </div>
</template>

<script>
import bimButton from "@bimlib/components/bimButton"
import ModalRequestVacancy from "@/pages/static/vacancy/ModalRequestVacancy"
export default {
  name: "BlockContent_Jobs",
  components: {
    bimButton,
    ModalRequestVacancy,
  },
  data() {
    return {
      requestVacancy: {
        show: false,
        select: "",
      },
      jobs: [
        {
          select: "javaDev",
          title: "Программист Java (Middle Java Developer)",
          desc: {
            expirience: "1-3 года",
            employment: "5/2 полный день",
            payment: "от 140 000 руб. на руки",
            other: [
              {
                title: "Обязанности:",
                items: [
                  "Разработка программных компонентов платформы BIMLIB",
                  "Участие в проектировании платформы",
                  "Review существующего кода и рефакторинг",
                  "Тестирование и документация разрабатываемых решений"
                ]
              },
              {
                title: "Мы ожидаем от соискателя:",
                items: [
                  "Способность выполнять порученную работу (желательно продемонстрировать портфолио выполненных проектов). Готовность решать сложные задачи.",
                  "Умение критически оценивать технологии разработки программного обеспечения.",
                  "Представление о современных средствах командной разработки и DevOps",
                  "Понимание парадигм программирования (императивное, функциональное, ...)",
                  "Представление о компонентах многоуровневых корпоративных приложений и интерфейсах их взаимодействия",
                  "Общее представление и знание основных паттернов проектирования",
                  "Понимание важности модульного и пр. видов тестирования"
                ]
              },
              {
                title: "Мы используем:",
                items: [
                  "Java 8+, Spring Framework, JPA/Hibernate ORM, JAX-RS/RESTEasy",
                  "PostgreSQL, Amazon S3/MinIO, Redis",
                  "RabbitMQ",
                  "Git/GitLab",
                  "Docker, Kubernetes",
                  "Vue.js/Quasar Framework",
                ]
              },
              {
                title: "От нас:",
                items: [
                  "Комфортный офис",
                  "Отсутствие бюрократии",
                  "Интересные задачи",
                  "Чай, печенье",
                ]
              }
            ]
          }
        },
        {
          select: "bk",
          title: "Специалист ОВиК / ВК (BIM)",
          desc: {
            expirience: "1-3 года",
            employment: "5/2 полный день",
            payment: "от 50 000 до 70 000 руб. на руки",
            other: [
              {
                title: "Обязанности:",
                items: [
                  "Разработка компонентов информационной модели (семейств) элементов отопления, вентиляции, кондиционирования, водоснабжения, канализации",
                  "Разработка технических заданий на создание моделей (семейств)",
                  "Общение с заказчиком по локальным задачам",
                  "Соблюдение внутренних регламентов",
                ]
              },
              {
                title: "Мы ожидаем от соискателя:",
                items: [
                  "Свободное владение ПК, Autodesk Revit, AutoCAD, MS Office (Word, Excel)",
                  "Опыт проектирования разделов ОВиК/ВК в Autodesk Revit не менее 1 года",
                  "Опыт в разработке семейств",
                  "Умение работать в Dynamo приветствуется",
                  "Умение грамотно излагать свои мысли как в живом общении так и «на бумаге»"
                ]
              },
              {
                title: "От нас:",
                items: [
                  "Комфортный офис",
                  "Отсутствие бюрократии",
                  "Интересные задачи",
                  "Чай, печенье",
                ]
              }
            ]
          }
        },
        {
          select: "analyst",
          title: "Аналитик/технический писатель",
          desc: {
            expirience: "1-3 года",
            employment: "5/2 полный день",
            payment: "от 70 000 руб. на руки",
            other: [
              {
                title: "Обязанности:",
                items: [
                  "Разработка и согласование функциональных и не функциональных требований к разрабатываемому программному обеспечению",
                  "Описание сценариев и алгоритмов работы программного обеспечения, форматов и протоколов информационного обмена между модулями, а также с внешними системами",
                  "Взаимодействие с командой проекта для сбора технической информации по проекту",
                  "Разработка и поддержание в актуальном состоянии технической, программной и эксплуатационной документации",
                  "Участие в разработке и внедрении шаблонов документов различного назначения"
                ]
              },
              {
                title: "Мы ожидаем от соискателя:",
                items: [
                  "Знание английского языка на уровне чтения технической документации",
                  "Умение правильно формулировать и корректно излагать свои мысли",
                  "Опыт в формализации требований и написании технических заданий для разработчиков",
                  "Знание языков моделирования систем и методологий UML, SysML, IDEF",
                  "Ответственность и внимание к деталям",
                ]
              },
              {
                title: "От нас:",
                items: [
                  "Комфортный офис",
                  "Отсутствие бюрократии",
                  "Интересные задачи",
                  "Чай, печенье",
                ]
              }
            ]
          }
        },
        {
          select: "sales",
          title: "Менеджер по продажам услуг",
          desc: {
            expirience: "1-3 года",
            employment: "5/2 полный день",
            payment: "от 70 000 руб. на руки",
            other: [
              {
                title: "Обязанности:",
                items: [
                  "Работа с потенциальными клиентами (поиск и привлечение)",
                  "Подготовка коммерческих предложений",
                  "Проведение переговоров и презентаций продукта по телефону и на встречах с клиентами",
                  "Участие в выставках, семинарах и конференциях с целью повышения заинтересованности клиентской аудитории в продуктах и услугах Компании",
                  "Ведение клиентской базы (amoCRM)",
                ]
              },
              {
                title: "Мы ожидаем от соискателя:",
                items: [
                  "Опыт личных или телефонных продаж",
                  "Опыт работы с первыми лицами компаний, проведения презентаций приветствуется",
                  "Опыт холодных звонков",
                  "Знание техник продаж и умение применять их на практике",
                  "Личностные качества: коммуникабельность, желание расти и развиваться в продажах, умение убеждать, ориентация на результат, ответственность, стрессоустойчивость, активность",
                ]
              },
              {
                title: "От нас:",
                items: [
                  "Комфортный офис",
                  "Отсутствие бюрократии",
                  "Интересные задачи",
                  "Чай, печенье",
                ]
              }
            ]
          }
        }
      ]
    }
  },
  mounted() {
    let snippets = document.querySelectorAll('.faq-dropdown')
    if (snippets.length > 0) {
      snippets.forEach(snippet => {
        snippet.children[0].onclick = () => { snippet.classList.toggle('faq-dropdown--active')}
      })
    }

    let hhScript = document.createElement('script');
    hhScript.setAttribute('src', 'https://api.hh.ru/widgets/vacancies/employer?employer_id=3101894&locale=RU&links_color=02a497&border_color=02a497&show_region=true');
    hhScript.setAttribute('class', 'hh-script');
    document.querySelector('.listVacancies_script').appendChild(hhScript);
  },
  methods: {
    openModalRequestVacancy(select) {
      this.requestVacancy.select = select
      this.requestVacancy.show = true
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/grid-settings";
@import "./src/front_white/sass/components/settings";
@import "./src/front_white/sass/components/athoms/faqDropdown";

.description__line {
  line-height: 1.5;
  letter-spacing: 0.2px;
  text-align: center;
  width: 55%;
  margin: auto;

  @media screen and (max-width: $breakpoint-sm) {
    width: 100%;
    font-size: 14px;
    line-height: 1.57;
    text-align: left;
  }
}

.vacancy {
  &_terms-block {
    &--margin:not(:last-child) {
      margin-right: 32px;
      @media screen and (max-width: $breakpoint-sm) {
        margin-right: 0;
        margin-bottom: 14px;
      }
    }
  }
  &_list {
    position: relative;
    padding-left: 26px;
    &-item {
      @include font-main(17px, normal, 1.41, normal, inherit);
      &:before {
        content: '-';
        position: absolute;
        left: 0;
      }
      &--margin:not(:last-child) {
        margin-bottom: 4px;
      }
    }
  }
  &_button {
    -webkit-text-fill-color: #fff;
  }
}

.block-job {
  .paragraph__title {
    font-size: 10px;
    text-transform: uppercase;
    line-height: 2;
    letter-spacing: 1px;
  }

  .paragraph__item {
    line-height: 1.42;
    font-size: 24px;
    font-weight: normal !important;
  }

  .paragraph-list__item {
    line-height: 1.5;
    letter-spacing: 0.2px;
    font-size: 18px;
  }

  .paragraph-list__title {
    font-size: 20px;
    line-height: 1.3;
  }
}
</style>
